module.exports = __webpack_public_path__ + "static/pcv-drivers-14992ada47a38e05550b49225b1fa4ab.jpg";